import React from 'react';
import {observer} from "mobx-react";
import {Link} from "react-router-dom";
import {ReadStatementDto} from "../../../model/statement/ReadStatementDto";
import {companyAccountsStore} from "../../../store/CompanyAccounts";
import {statementApi} from "../../../backend/StatementApi";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {Button, Grid} from "@mui/material";
import ButtonWithConfirmation from "../../../components/button/ButtonWithConfirmation";
import MyMaterialTable from "../../../components/mtable/MyMaterialTable";
import {StatementStateEnum} from "../../../model/statement/StatementStateEnum";
import {ActionMap} from "../../../utils/ActionMap";
import UploadStatementStrip from "./UploadStatementStrip";
import {routes} from "../../../main/Routes";

interface IProps {
    statements: ReadStatementDto[],
    statementsChanged: () => void
}

interface IState {
}

const STATEMENT_STATE_CHANGES = new ActionMap<StatementStateEnum, [string], Promise<void>>()
        .on(StatementStateEnum.ARCHIVED).do(id => statementApi.unarchiveStatement(id))
        .on(StatementStateEnum.OPEN).do(id => statementApi.archiveStatement(id))
        .selector()

class StatementsTable extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {

    }

    render() {
        const statements = this.props.statements;
        return <>
            <Grid container>
                <Grid item xs={12}>
                    <MyMaterialTable
                            columns={[
                                {title: '#', field: 'index', width: "5%", align: "center"},
                                {title: 'From', field: 'periodFrom', type: "date",},
                                {title: 'To', field: 'periodTo', type: "date"},
                                {
                                    title: 'Name', render: (row) => {
                                        const bank = companyAccountsStore.findByIban(row.iban, row.currency);
                                        return bank?.name ?? ""
                                    }
                                },
                                {title: 'IBAN', field: 'iban',},
                                {title: 'Currency', field: 'currency'},
                            ]}
                            data={statements.map((it, index) => {
                                return {...it, index: index};
                            })}

                            style={{width: "100%"}}

                            options={{
                                toolbar: false,
                                search: false,
                                sorting: false,
                                paging: false,
                                draggable: false,
                                tableLayout: "auto",
                                actionsColumnIndex: 6,
                            }}

                            actions={[
                                row => ({
                                    icon: () => <Button variant="contained" color="primary" startIcon={<EditIcon/>}
                                                        component={Link} to={routes.singleStatement.replace(':id', row.id)}>Open</Button>,
                                    onClick: () => {
                                    }
                                }),
                                row => ({
                                    icon: () => <ButtonWithConfirmation variant="contained" color="secondary"
                                                                        onClick={this.deleteStatement(row.id)}
                                                                        startIcon={<DeleteIcon/>}>
                                        X
                                    </ButtonWithConfirmation>,
                                    onClick: () => {
                                    }
                                }),
                                row => ({
                                    icon: () => (
                                            <Button onClick={this.changeArchiveStatus(row)}>
                                                {this.isArchived(row) ? 'Unarchive' : 'Archive'}
                                            </Button>
                                    ),
                                    onClick: () => null
                                }),
                            ]}
                    />
                </Grid>
                <Grid item xs={12}>
                    <UploadStatementStrip/>
                </Grid>
            </Grid>

        </>
    }

    private deleteStatement = (id: string) => async () => {
        await statementApi.deleteStatement(id);
        await this.props.statementsChanged();
    }

    private changeArchiveStatus = (stmt: ReadStatementDto) => async () => {
        await STATEMENT_STATE_CHANGES.for(stmt.state).execute(stmt.id)
        await this.props.statementsChanged();
    }

    private isArchived(stmt: ReadStatementDto) {
        return stmt.state === StatementStateEnum.ARCHIVED;
    }
}

export default observer(StatementsTable);